import { readJson } from '@ms-cloudpack/json-utilities';
import type { UserPreferences } from '@ms-cloudpack/common-types';
import { getUserPreferencesPath } from './getUserPreferencesPath.js';

/**
 * Reads the user preferences file asynchronously.
 */
export async function readUserPreferences(): Promise<UserPreferences> {
  const { $schema, ...prefs } =
    (await readJson<UserPreferences & { $schema?: string }>(getUserPreferencesPath(), {
      verbose: true,
      mode: 'permissive',
    })) || {};

  return prefs;
}
